import * as React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/utils";
import { ChevronRight } from "lucide-react";

/**
 * Breadcrumbs component for application navigation
 *
 * @param {Object} props
 * @param {Array} props.items - Array of breadcrumb items with text and href properties
 * @param {string} props.className - Additional classes for the breadcrumbs container
 * @param {React.ReactNode} props.separator - Custom separator element (defaults to ChevronRight)
 */
const Breadcrumbs = ({
  items = [],
  className,
  separator = <ChevronRight className="h-4 w-4 mx-2 text-muted-foreground" />,
  ...props
}) => {
  // Make sure we have items to display
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav
      className={cn("flex items-center flex-wrap text-sm", className)}
      aria-label="Breadcrumbs"
      {...props}
    >
      <ol className="flex items-center flex-wrap">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={index} className="flex items-center">
              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  className="text-primary hover:underline transition-colors duration-200 font-medium"
                >
                  {item.text}
                </Link>
              ) : (
                <span
                  className={cn(
                    isLast ? "font-medium" : "text-muted-foreground",
                    "truncate"
                  )}
                >
                  {item.text}
                </span>
              )}

              {!isLast && separator}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export { Breadcrumbs };
